import { Eye } from "lucide-react";

import { useTranslation } from "@/lib/i18n";
import Stack from "@/components/stack/stack";
import type { Configuration } from "@/features/widget-forms/forms/weather-model-map/types";

import styles from "./modal-map-preview.module.css";

interface ModalMapPreviewProps {
  configuration?: Configuration;
}

// eslint-disable-next-line no-empty-pattern
function ModalMapPreview({}: ModalMapPreviewProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.previewBox}>
      <Stack flexDirection="column" alignItems="center" gap={8}>
        <Eye size={48} />
        <span>{t("admin.widgets.fields.model_map.preview.placeholder")}</span>
      </Stack>
    </div>
  );
}

export default ModalMapPreview;
